import React, { useMemo, useState, useEffect } from "react";
import CustomCard from "../../components/CustomCard";
import CustomDropdown from "../../components/CustomDropdown";
import CustomButton from "../../components/CustomButton";
import Popup from "../../components/Popup";
import { useNavigate } from "react-router-dom";
import "../css/InformationAccount.css";
import "../css/companyRegulation.css";
import { useTranslation } from "react-i18next";
import countries from "world-countries";
import { createRegulationCompanyMT5Account, fetchAndStoreServerPublicKey, API_ROUTES, decryptResponseMessages } from "../../utils/apiClient";
import AppConstants from "../../utils/appConstants";
import { UserDocumentSubType } from "../../utils/enums";
import axios from "axios";
import rsaController from "../../utils/RSA-controller";

export default function CompanyRegulation() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // Company fields state (for future submit)
    const [name, setName] = useState("");
    const [regNumber, setRegNumber] = useState("");
    const [regDate, setRegDate] = useState("");
    const [regAuthority, setRegAuthority] = useState("");
    const [vat, setVat] = useState("");
    const [lei, setLei] = useState("");
    const [licenseNumber, setLicenseNumber] = useState("");
    const [licenseAuthority, setLicenseAuthority] = useState("");
    const [country, setCountry] = useState("");
    const [address, setAddress] = useState("");
    const [website, setWebsite] = useState("");
    const [companyType, setCompanyType] = useState("");
    const [companyDescription, setCompanyDescription] = useState("");
    const [estimatedRevenue, setEstimatedRevenue] = useState("");
    const [sourceOfFunds, setSourceOfFunds] = useState("");
    const [taxResidency, setTaxResidency] = useState("");
    const [sectorClassification, setSectorClassification] = useState("");
    const [financialStatus, setFinancialStatus] = useState("");
    const [bankName, setBankName] = useState("");
    const [opsPace, setOpsPace] = useState("");
    const [avgTxAmount, setAvgTxAmount] = useState("");
    const [expectedAnnualActivity, setExpectedAnnualActivity] = useState("");

    // Economic Owners field
    const [numberOfEconomicOwners, setNumberOfEconomicOwners] = useState("");

    // Authorized Signatories field
    const [numberOfAuthorizedSignatories, setNumberOfAuthorizedSignatories] = useState("");

    // Main Shareholder (USER_ENTITY_SHAREHOLDER) fields
    const [mainShareholderFullName, setMainShareholderFullName] = useState("");
    const [mainShareholderNationality, setMainShareholderNationality] = useState("");
    const [mainShareholderDateOfBirth, setMainShareholderDateOfBirth] = useState("");
    const [mainShareholderOwnershipPercentage, setMainShareholderOwnershipPercentage] = useState("");
    const [mainShareholderIsPep, setMainShareholderIsPep] = useState(false);
    const [mainShareholderDocumentType, setMainShareholderDocumentType] = useState(null); // 0=ID CARD, 1=PASSPORT
    const [mainShareholderFrontImage, setMainShareholderFrontImage] = useState(null);
    const [mainShareholderFrontImagePreview, setMainShareholderFrontImagePreview] = useState(null);
    const [mainShareholderBackImage, setMainShareholderBackImage] = useState(null);
    const [mainShareholderBackImagePreview, setMainShareholderBackImagePreview] = useState(null);
    const [mainShareholderMainImage, setMainShareholderMainImage] = useState(null);
    const [mainShareholderMainImagePreview, setMainShareholderMainImagePreview] = useState(null);

    // Board of Directors fields
    const [boardOfDirectorsFullName, setBoardOfDirectorsFullName] = useState("");
    const [boardOfDirectorsNationality, setBoardOfDirectorsNationality] = useState("");
    const [boardOfDirectorsDateOfBirth, setBoardOfDirectorsDateOfBirth] = useState("");
    const [boardOfDirectorsPosition, setBoardOfDirectorsPosition] = useState("");
    const [boardOfDirectorsIsPep, setBoardOfDirectorsIsPep] = useState(false);
    const [boardOfDirectorsDocumentType, setBoardOfDirectorsDocumentType] = useState(null); // 0=ID CARD, 1=PASSPORT
    const [boardOfDirectorsFrontImage, setBoardOfDirectorsFrontImage] = useState(null);
    const [boardOfDirectorsFrontImagePreview, setBoardOfDirectorsFrontImagePreview] = useState(null);
    const [boardOfDirectorsBackImage, setBoardOfDirectorsBackImage] = useState(null);
    const [boardOfDirectorsBackImagePreview, setBoardOfDirectorsBackImagePreview] = useState(null);
    const [boardOfDirectorsMainImage, setBoardOfDirectorsMainImage] = useState(null);
    const [boardOfDirectorsMainImagePreview, setBoardOfDirectorsMainImagePreview] = useState(null);
    const [boardOfDirectorsOwnerPercentage, setBoardOfDirectorsOwnerPercentage] = useState("");

    // Beneficial Right Owner fields
    const [beneficialRightOwnerType, setBeneficialRightOwnerType] = useState(null); // "same" or "other"
    const [beneficialRightOwnerFullName, setBeneficialRightOwnerFullName] = useState("");
    const [beneficialRightOwnerAddress, setBeneficialRightOwnerAddress] = useState("");
    const [beneficialRightOwnerMobilePhone, setBeneficialRightOwnerMobilePhone] = useState("");
    const [beneficialRightOwnerFrontImage, setBeneficialRightOwnerFrontImage] = useState(null);
    const [beneficialRightOwnerFrontImagePreview, setBeneficialRightOwnerFrontImagePreview] = useState(null);
    const [beneficialRightOwnerBackImage, setBeneficialRightOwnerBackImage] = useState(null);
    const [beneficialRightOwnerBackImagePreview, setBeneficialRightOwnerBackImagePreview] = useState(null);

    // Company Document fields
    const [companyDocumentArticleOfIncorporation, setCompanyDocumentArticleOfIncorporation] = useState(null);
    const [companyDocumentArticleOfIncorporationPreview, setCompanyDocumentArticleOfIncorporationPreview] = useState(null);
    const [companyDocumentCommercialRegistration, setCompanyDocumentCommercialRegistration] = useState(null);
    const [companyDocumentCommercialRegistrationPreview, setCompanyDocumentCommercialRegistrationPreview] = useState(null);
    const [companyDocumentCommercialCircular, setCompanyDocumentCommercialCircular] = useState(null);
    const [companyDocumentCommercialCircularPreview, setCompanyDocumentCommercialCircularPreview] = useState(null);

    // Compliance Officer fields
    const [complianceOfficerFirstName, setComplianceOfficerFirstName] = useState("");
    const [complianceOfficerLastName, setComplianceOfficerLastName] = useState("");
    const [complianceOfficerFathersName, setComplianceOfficerFathersName] = useState("");
    const [complianceOfficerMotherName, setComplianceOfficerMotherName] = useState("");
    const [complianceOfficerGender, setComplianceOfficerGender] = useState(null);
    const [complianceOfficerRegNumber, setComplianceOfficerRegNumber] = useState("");
    const [complianceOfficerRegPlace, setComplianceOfficerRegPlace] = useState("");
    const [complianceOfficerIdNumber, setComplianceOfficerIdNumber] = useState("");
    const [complianceOfficerIdentificationImage, setComplianceOfficerIdentificationImage] = useState(null);
    const [complianceOfficerIdentificationImagePreview, setComplianceOfficerIdentificationImagePreview] = useState(null);
    const [complianceOfficerBasedInLebanon, setComplianceOfficerBasedInLebanon] = useState(0); // 0=No, 1=Yes
    const [complianceOfficerHasOwnership, setComplianceOfficerHasOwnership] = useState(0); // 0=No, 1=Yes
    const [complianceOfficerOwnedPercentage, setComplianceOfficerOwnedPercentage] = useState("");

    // Legal Representative fields
    const [legalRepFirstName, setLegalRepFirstName] = useState("");
    const [legalRepLastName, setLegalRepLastName] = useState("");
    const [legalRepFathersName, setLegalRepFathersName] = useState("");
    const [legalRepMotherName, setLegalRepMotherName] = useState("");
    const [legalRepGender, setLegalRepGender] = useState(null);
    const [legalRepRegNumber, setLegalRepRegNumber] = useState("");
    const [legalRepRegPlace, setLegalRepRegPlace] = useState("");
    const [legalRepIdNumber, setLegalRepIdNumber] = useState("");
    const [legalRepIdentificationImage, setLegalRepIdentificationImage] = useState(null);
    const [legalRepIdentificationImagePreview, setLegalRepIdentificationImagePreview] = useState(null);
    const [legalRepBasedInLebanon, setLegalRepBasedInLebanon] = useState(0); // 0=No, 1=Yes
    const [legalRepHasOwnership, setLegalRepHasOwnership] = useState(0); // 0=No, 1=Yes
    const [legalRepOwnedPercentage, setLegalRepOwnedPercentage] = useState("");

    // Board Chairman fields
    const [boardChairmanFirstName, setBoardChairmanFirstName] = useState("");
    const [boardChairmanLastName, setBoardChairmanLastName] = useState("");
    const [boardChairmanFathersName, setBoardChairmanFathersName] = useState("");
    const [boardChairmanMotherName, setBoardChairmanMotherName] = useState("");
    const [boardChairmanGender, setBoardChairmanGender] = useState(null);
    const [boardChairmanRegNumber, setBoardChairmanRegNumber] = useState("");
    const [boardChairmanRegPlace, setBoardChairmanRegPlace] = useState("");
    const [boardChairmanIdNumber, setBoardChairmanIdNumber] = useState("");
    const [boardChairmanIdentificationImage, setBoardChairmanIdentificationImage] = useState(null);
    const [boardChairmanIdentificationImagePreview, setBoardChairmanIdentificationImagePreview] = useState(null);
    const [boardChairmanBasedInLebanon, setBoardChairmanBasedInLebanon] = useState(0); // 0=No, 1=Yes
    const [boardChairmanHasOwnership, setBoardChairmanHasOwnership] = useState(0); // 0=No, 1=Yes
    const [boardChairmanOwnedPercentage, setBoardChairmanOwnedPercentage] = useState("");

    // Loading and error states
    const [loading, setLoading] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [errorPopupMessage, setErrorPopupMessage] = useState("");
    // Field-level errors for red border highlighting
    const [fieldErrors, setFieldErrors] = useState({});

    // Country dropdown options (same pattern as UrbanInfo)
    const countryOptions = useMemo(() => {
        return countries
            .filter((country) => country.cca2 !== 'il') // Remove Israel
            .map((c) => ({
                value: c.cca2,
                label: `${c.name.common} (${c.cca2})`,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, []);

    // Initialize server public key
    useEffect(() => {
        const initializeServerKey = async () => {
            try {
                await fetchAndStoreServerPublicKey();
            } catch (error) {
            }
        };
        initializeServerKey();
    }, []);

    // Helper function to convert gender (0/1) to string ("Male"/"Female")
    const getGenderString = (genderValue) => {
        if (genderValue === 0) return "Male";
        if (genderValue === 1) return "Female";
        return null;
    };

    // Helper function to format date to YYYY-MM-DD (for company reg date)
    const formatDate = (dateString) => {
        if (!dateString) return null;
        // If already in YYYY-MM-DD format, return as is
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }
        // Try to parse and format
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Helper function to format date to ISO 8601 (for DATE_OF_BIRTH)
    const formatDateToISO8601 = (dateString) => {
        if (!dateString) return null;
        // If already in ISO format, return as is
        if (/^\d{4}-\d{2}-\d{2}T/.test(dateString)) {
            return dateString;
        }
        // Try to parse and format to ISO 8601
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;
        // Return ISO 8601 format with time (matches Flutter's toIso8601String())
        return date.toISOString();
    };

    // Helper function to convert string to number (for percentages, amounts)
    const toNumber = (value) => {
        if (value === null || value === undefined || value === "") return null;
        const num = parseFloat(value);
        return isNaN(num) ? null : num;
    };

    // Helper function to upload company documents (Main Shareholder + Board of Directors)
    // Matches Flutter's CREATE_USER_DOCUMENTS structure exactly
    const uploadCompanyDocuments = async (email) => {
        try {
            // Import helper functions dynamically
            const apiClientModule = await import("../../utils/apiClient");
            const { hashSecretKey } = await import("../../utils/passwordHasher");
            
            // Build extraInfo using the same logic as apiClient
            const getDeviceOS = () => {
                const userAgent = navigator.userAgent || navigator.platform || 'Unknown';
                if (/Win/.test(userAgent)) return 'Windows';
                if (/Mac/.test(userAgent)) return 'MacOS';
                if (/Android/.test(userAgent)) return 'Android';
                if (/iPhone|iPad|iPod/.test(userAgent)) return 'iOS';
                return navigator.platform || 'Unknown';
            };

            const getDeviceModel = () => {
                const userAgent = navigator.userAgent || '';
                if (/iPhone/.test(userAgent)) {
                    const match = userAgent.match(/iPhone(\d+,\d+)/);
                    return match ? `iPhone ${match[1]}` : 'iPhone';
                }
                if (/iPad/.test(userAgent)) return 'iPad';
                if (/Android/.test(userAgent)) {
                    const match = userAgent.match(/Android\s([^;)]+)/);
                    return match ? match[1] : 'Android Device';
                }
                return navigator.platform || 'Unknown';
            };

            const getDeviceName = () => 'Unknown Device';

            const getDevicePosition = () => {
                return new Promise((resolve) => {
                    if (!navigator.geolocation) {
                        resolve({ latitude: null, longitude: null });
                        return;
                    }
                    navigator.geolocation.getCurrentPosition(
                        (position) => resolve({
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        }),
                        () => resolve({ latitude: null, longitude: null }),
                        { timeout: 5000 }
                    );
                });
            };

            const position = await getDevicePosition();
            const secretKey = process.env.REACT_APP_SECRET_KEY;
            if (!secretKey) {
                throw new Error('REACT_APP_SECRET_KEY is not set');
            }
            const hashedSecretKey = await hashSecretKey(secretKey);
            
            const extraInfo = {
                'device-id': getDeviceName() + '-' + getDeviceOS(),
                'device-os': getDeviceOS(),
                'device-model': getDeviceModel(),
                'device-name': getDeviceName(),
                'device-ip': 'null',
                'device-position': JSON.stringify({
                    LATITUDE: position.latitude || 0,
                    LONGTITUDE: position.longitude || 0
                }),
                'secret-key': hashedSecretKey,
                'user-type': '0'
            };

            const publicKey = await rsaController.getUserPublicKey();
            
            // Build USER_DOCUMENTS structure (matches Flutter exactly)
            const userDocuments = {
                'SELFIE_IMAGE': UserDocumentSubType.SELFIE,
                'FRONT_ID_IMAGE': null,
                'BACK_ID_IMAGE': '',
                'ADDRESS_IMAGE': null,
                'SHAREHOLDER_DOCUMENT_TYPE': mainShareholderDocumentType !== null && mainShareholderDocumentType !== undefined
                    ? (mainShareholderDocumentType === 0 ? UserDocumentSubType.ID_CARD : UserDocumentSubType.PASSPORT)
                    : null,
                'DIRECTOR_DOCUMENT_TYPE': boardOfDirectorsDocumentType !== null && boardOfDirectorsDocumentType !== undefined
                    ? (boardOfDirectorsDocumentType === 0 ? UserDocumentSubType.ID_CARD : UserDocumentSubType.PASSPORT)
                    : null,
                'BENIFICAL_DOCUMENT_TYPE': UserDocumentSubType.ID_CARD,
                'SIGNATURE_DOCUMENT_TYPE': UserDocumentSubType.SIGNATURE,
                'SIGNATURE_VIDEO_TYPE': UserDocumentSubType.SIGNATURE_VIDEO,
                'SIGNATURE_CHECK_TYPE': UserDocumentSubType.CHECK_SIGNATURE,
            };

            // Get leverage from saved step1 data (same as in handleSubmit)
            const getLeverage = async () => {
                const savedStep1Data = sessionStorage.getItem('registration_step1_data') || localStorage.getItem('registration_step1_data');
                if (savedStep1Data) {
                    try {
                        const step1Data = JSON.parse(savedStep1Data);
                        if (step1Data.leverage) {
                            const leverageValue = typeof step1Data.leverage === 'object' ? step1Data.leverage.value : step1Data.leverage;
                            // Extract number from "1:100" format
                            const match = leverageValue.toString().match(/1:(\d+)/);
                            if (match) {
                                const intValue = parseInt(match[1], 10);
                                if (!isNaN(intValue)) {
                                    return intValue;
                                }
                            }
                            // If not in "1:100" format, try to parse as number directly
                            const numValue = parseInt(leverageValue, 10);
                            if (!isNaN(numValue)) {
                                return numValue;
                            }
                        }
                    } catch (e) {
                    }
                }
                
                // If not found in step1Data, try to get current leverage from backend
                try {
                    const { getTradingInfos } = await import('../../utils/apiClient');
                    const tradingResponse = await getTradingInfos();
                    const leverageValue = tradingResponse?.decryptedData?.DATA?.LEVERAGE || 
                                         tradingResponse?.decryptedData?.DATA?.leverage ||
                                         tradingResponse?.data?.DATA?.LEVERAGE ||
                                         tradingResponse?.data?.DATA?.leverage;
                    
                    if (leverageValue) {
                        const intValue = parseInt(leverageValue, 10);
                        if (!isNaN(intValue)) {
                            return intValue;
                        }
                    }
                } catch (error) {
                    // Continue to default value
                }
                
                // Only default to 100 if we can't get it from anywhere
                return 100; // Default leverage
            };

            const leverage = await getLeverage();

             // Build data structure (matches Flutter) - IS_CREATE = 0 for company documents
            const dataToEncrypt = {
                HEADERS: extraInfo,
                BODY: {
                    EMAIL: email,
                    USER_DOCUMENTS: userDocuments,
                    DEFAULT_LEVERAGE: leverage,
                     IS_CREATE: 0  // 0 for company document upload (regulation flow)
                }
            };

            // Encrypt data (same logic as apiClient.encryptData)
            const dataString = JSON.stringify(dataToEncrypt);
            const segmentSizeBits = 2048;
            const segmentSizeBytes = segmentSizeBits / 8;
            
            const encoder = new TextEncoder();
            const dataBytes = encoder.encode(dataString);
            const dataByteLength = dataBytes.length;
            
            let encryptedResult;
            if (dataByteLength <= segmentSizeBytes) {
                encryptedResult = await rsaController.encryptWithServerKey(dataString);
            } else {
                const numSegments = Math.ceil(dataByteLength / segmentSizeBytes);
                const segmentsEncrypted = [];
                
                for (let i = 0; i < numSegments; i++) {
                    const startByte = i * segmentSizeBytes;
                    const endByte = Math.min((i + 1) * segmentSizeBytes, dataByteLength);
                    const segmentBytes = dataBytes.slice(startByte, endByte);
                    const segment = new TextDecoder().decode(segmentBytes);
                    const encryptedChunk = await rsaController.encryptWithServerKey(segment);
                    segmentsEncrypted.push(encryptedChunk);
                }
                
                encryptedResult = segmentsEncrypted;
            }
            
            const messagesArray = Array.isArray(encryptedResult) 
                ? encryptedResult 
                : [encryptedResult];

            // Build imageData map (matches Flutter structure)
            const imageData = {};
            
            // Main Shareholder images
            if (mainShareholderDocumentType === 0) {
                // ID Card: front and back
                if (mainShareholderFrontImage) {
                    imageData['SHAREHOLDER_FT_IMAGE'] = mainShareholderFrontImage;
                }
                if (mainShareholderBackImage) {
                    imageData['SHAREHOLDER_BK_IMAGE'] = mainShareholderBackImage;
                }
            } else if (mainShareholderDocumentType === 1) {
                // Passport: main image as front image
                if (mainShareholderMainImage) {
                    imageData['SHAREHOLDER_FT_IMAGE'] = mainShareholderMainImage;
                }
            }

            // Board of Directors images
            // For ID CARD (documentType === 0): use front and back images
            // For PASSPORT (documentType === 1): use main image as front image
            if (boardOfDirectorsDocumentType === 0) {
                // ID Card: front and back
                if (boardOfDirectorsFrontImage) {
                    imageData['DIRECTOR_FT_IMAGE'] = boardOfDirectorsFrontImage;
                }
                if (boardOfDirectorsBackImage) {
                    imageData['DIRECTOR_BK_IMAGE'] = boardOfDirectorsBackImage;
                }
            } else if (boardOfDirectorsDocumentType === 1) {
                // Passport: main image as front image
                if (boardOfDirectorsMainImage) {
                    imageData['DIRECTOR_FT_IMAGE'] = boardOfDirectorsMainImage;
                }
            }

            // Company Documents
            if (companyDocumentArticleOfIncorporation) {
                imageData['INCORPORATION_IMAGE'] = companyDocumentArticleOfIncorporation;
            }
            if (companyDocumentCommercialRegistration) {
                imageData['COM_REGISTRATION_IMAGE'] = companyDocumentCommercialRegistration;
            }
            if (companyDocumentCommercialCircular) {
                imageData['COM_CIRCULAR_IMAGE'] = companyDocumentCommercialCircular;
            }

            const fullUrl = API_ROUTES.CREATE_USER_DOCUMENTS_MT5_ACCOUNT;

            // Create FormData for multipart/form-data request (matches Flutter's postDataAndImage)
            const formData = new FormData();
            formData.append('MESSAGES', JSON.stringify(messagesArray));
            formData.append('PUBLIC_KEY', publicKey);
            formData.append('TYPE', '0');
            formData.append('VERSION_CODE', '0.5.9');

            // Add image files
            for (const [key, file] of Object.entries(imageData)) {
                if (file) {
                    formData.append(key, file, file.name || 'image.jpg');
                }
            }

            const headers = {
                // Don't set Content-Type - browser will set it with boundary for FormData
            };

            // Get token for Authorization header
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            if (token && token !== 'FIRST_TIME_LOGIN') {
                headers['Authorization'] = `Bearer ${token}`;
            }

            const response = await axios.post(fullUrl, formData, { headers });

            const decryptedResponse =
              (await decryptResponseMessages(response.data)) || response.data;

            return {
                ...response,
                decryptedData: decryptedResponse
            };
        } catch (error) {
            throw error;
        }
    };

    // Build EconomicSector-like object (for ECONOMIC_OWNERS, COMPLIANCE_OFFICER, etc.)
    const buildEconomicSector = (data) => {
        const obj = {};
        if (data.firstName) obj.FIRST_NAME = data.firstName;
        if (data.lastName) obj.LAST_NAME = data.lastName;
        if (data.fathersName) obj.FATHERS_NAME = data.fathersName;
        if (data.motherName) obj.MOTHER_NAME = data.motherName;
        if (data.gender !== null && data.gender !== undefined) {
            obj.GENDER = getGenderString(data.gender);
        }
        if (data.regNumber) obj.REG_NUMBER = data.regNumber;
        if (data.regPlace) obj.REG_PLACE = data.regPlace;
        if (data.idNumber) obj.ID_NUMBER = data.idNumber;
        // IDENTIFICATION_IMAGE_ID - set to null for now (would need image upload API)
        if (data.identificationImageId !== null && data.identificationImageId !== undefined) {
            obj.IDENTIFICATION_IMAGE_ID = data.identificationImageId;
        }
        if (data.basedInLebanon !== null && data.basedInLebanon !== undefined) {
            obj.BASED_IN_LEBANON = data.basedInLebanon === 1 ? 1 : 0;
        }
        if (data.hasOwnership !== null && data.hasOwnership !== undefined) {
            obj.HAS_OWNERSHIP = data.hasOwnership === 1 ? 1 : 0;
        }
        if (data.ownedPercentage !== null && data.ownedPercentage !== undefined && data.ownedPercentage !== "") {
            const percentage = toNumber(data.ownedPercentage);
            if (percentage !== null) obj.OWNED_PERCENTAGE = percentage;
        }
        return obj;
    };

    // Handle form submission
    const handleSubmit = async () => {
        setLoading(true);
        setErrorPopupMessage("");
        setShowErrorPopup(false);

        try {
            // Get email from localStorage
            const email = localStorage.getItem('registrationEmail') || localStorage.getItem('userEmail');
            if (!email) {
                setErrorPopupMessage(t("companyRegulation.errors.emailRequired") || "Email is required. Please complete registration first.");
                setShowErrorPopup(true);
                setLoading(false);
                return;
            }

            // Validate required fields for Company Regulation - Company section and key counts
            const missingFields = [];
            const newFieldErrors = {};

            if (!name || name.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.name") || "Company Name");
                newFieldErrors.name = true;
            }
            if (!regNumber || regNumber.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.registrationNumber") || "Registration Number");
                newFieldErrors.regNumber = true;
            }
            if (!regDate) {
                missingFields.push(t("companyRegulation.labels.company.regDate") || "Registration Date");
                newFieldErrors.regDate = true;
            }
            if (!regAuthority || regAuthority.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.regAuthority") || "Registration Authority");
                newFieldErrors.regAuthority = true;
            }
            if (!companyType || companyType.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.companyType") || "Company Type");
                newFieldErrors.companyType = true;
            }
            if (!lei || lei.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.lei") || "LEI");
                newFieldErrors.lei = true;
            }
            if (!country || country.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.country") || "Country");
                newFieldErrors.country = true;
            }
            if (!licenseAuthority || licenseAuthority.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.licenseAuthority") || "License Authority");
                newFieldErrors.licenseAuthority = true;
            }
            if (!licenseNumber || licenseNumber.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.licenseNumber") || "License Number");
                newFieldErrors.licenseNumber = true;
            }
            if (!address || address.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.address") || "Address");
                newFieldErrors.address = true;
            }
            if (!website || website.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.website") || "Website");
                newFieldErrors.website = true;
            }
            if (!companyDescription || companyDescription.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.companyDescription") || "Company Description");
                newFieldErrors.companyDescription = true;
            }
            if (!vat || vat.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.vat") || "VAT Number");
                newFieldErrors.vat = true;
            }
            if (!estimatedRevenue || estimatedRevenue.toString().trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.estimatedRevenue") || "Estimated Annual Revenue");
                newFieldErrors.estimatedRevenue = true;
            }
            if (!sourceOfFunds || sourceOfFunds.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.sourceOfFunds") || "Source of Funds");
                newFieldErrors.sourceOfFunds = true;
            }
            if (!taxResidency || taxResidency.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.taxResidency") || "Tax Residency");
                newFieldErrors.taxResidency = true;
            }
            if (!sectorClassification || sectorClassification.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.sectorClassification") || "Sector Classification");
                newFieldErrors.sectorClassification = true;
            }
            if (!financialStatus || financialStatus.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.financialStatus") || "Financial Status");
                newFieldErrors.financialStatus = true;
            }
            if (!bankName || bankName.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.bankName") || "Bank Name");
                newFieldErrors.bankName = true;
            }
            if (!opsPace || opsPace.trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.opsPace") || "Operations Pace");
                newFieldErrors.opsPace = true;
            }
            if (!avgTxAmount || avgTxAmount.toString().trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.avgTxAmount") || "Average Transaction Amount");
                newFieldErrors.avgTxAmount = true;
            }
            if (!expectedAnnualActivity || expectedAnnualActivity.toString().trim() === "") {
                missingFields.push(t("companyRegulation.labels.company.expectedAnnualActivity") || "Expected Annual Activity");
                newFieldErrors.expectedAnnualActivity = true;
            }
            if (!numberOfEconomicOwners && numberOfEconomicOwners !== 0) {
                missingFields.push(t("companyRegulation.labels.economicOwners.numberOfEconomicOwners") || "Number of Economic Owners");
                newFieldErrors.numberOfEconomicOwners = true;
            }
            if (!numberOfAuthorizedSignatories && numberOfAuthorizedSignatories !== 0) {
                missingFields.push(t("companyRegulation.labels.authorizedSignatories.numberOfAuthorizedSignatories") || "Number of Authorized Signatories");
                newFieldErrors.numberOfAuthorizedSignatories = true;
            }

            if (missingFields.length > 0) {
                setFieldErrors(newFieldErrors);
                const baseMessage = t("companyRegulation.errors.requiredFields") || "Please fill all required fields:";
                setErrorPopupMessage(`${baseMessage} ${missingFields.join(", ")}`);
                setShowErrorPopup(true);
                setLoading(false);
                return;
            }
            // Clear field errors if all fields are valid
            setFieldErrors({});

            // Validate required fields for Board of Directors (if director name is provided, all fields are required)
            if (boardOfDirectorsFullName && boardOfDirectorsFullName.trim() !== "") {
                if (!boardOfDirectorsNationality || boardOfDirectorsNationality.trim() === "") {
                    setErrorPopupMessage(t("companyRegulation.errors.directorNationalityRequired") || "Director nationality is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (!boardOfDirectorsDateOfBirth) {
                    setErrorPopupMessage(t("companyRegulation.errors.directorDateOfBirthRequired") || "Director date of birth is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (!boardOfDirectorsPosition || boardOfDirectorsPosition.trim() === "") {
                    setErrorPopupMessage(t("companyRegulation.errors.directorPositionRequired") || "Director position is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (!boardOfDirectorsOwnerPercentage || boardOfDirectorsOwnerPercentage.trim() === "") {
                    setErrorPopupMessage(t("companyRegulation.errors.directorOwnershipRequired") || "Director ownership percentage is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (boardOfDirectorsDocumentType === null || boardOfDirectorsDocumentType === undefined) {
                    setErrorPopupMessage(t("companyRegulation.errors.directorDocumentTypeRequired") || "Director document type is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
            }

            // Validate required fields for Main Shareholder (if shareholder name is provided, all fields are required)
            if (mainShareholderFullName && mainShareholderFullName.trim() !== "") {
                if (!mainShareholderNationality || mainShareholderNationality.trim() === "") {
                    setErrorPopupMessage(t("companyRegulation.errors.shareholderNationalityRequired") || "Shareholder nationality is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (!mainShareholderDateOfBirth) {
                    setErrorPopupMessage(t("companyRegulation.errors.shareholderDateOfBirthRequired") || "Shareholder date of birth is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (!mainShareholderOwnershipPercentage || mainShareholderOwnershipPercentage.trim() === "") {
                    setErrorPopupMessage(t("companyRegulation.errors.shareholderOwnershipRequired") || "Shareholder ownership percentage is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
                if (mainShareholderDocumentType === null || mainShareholderDocumentType === undefined) {
                    setErrorPopupMessage(t("companyRegulation.errors.shareholderDocumentTypeRequired") || "Shareholder document type is required.");
                    setShowErrorPopup(true);
                    setLoading(false);
                    return;
                }
            }

            // Get leverage from saved step1 data (matches personalInformation.js pattern)
            const getLeverage = async () => {
                const savedStep1Data = sessionStorage.getItem('registration_step1_data') || localStorage.getItem('registration_step1_data');
                if (savedStep1Data) {
                    try {
                        const step1Data = JSON.parse(savedStep1Data);
                        if (step1Data.leverage) {
                            const leverageValue = typeof step1Data.leverage === 'object' ? step1Data.leverage.value : step1Data.leverage;
                            // Extract number from "1:100" format
                            const match = leverageValue.toString().match(/1:(\d+)/);
                            if (match) {
                                const intValue = parseInt(match[1], 10);
                                if (!isNaN(intValue)) {
                                    return intValue;
                                }
                            }
                            // If not in "1:100" format, try to parse as number directly
                            const numValue = parseInt(leverageValue, 10);
                            if (!isNaN(numValue)) {
                                return numValue;
                            }
                        }
                    } catch (e) {
                    }
                }
                
                // If not found in step1Data, try to get current leverage from backend
                try {
                    const { getTradingInfos } = await import('../../utils/apiClient');
                    const tradingResponse = await getTradingInfos();
                    const leverageValue = tradingResponse?.decryptedData?.DATA?.LEVERAGE || 
                                         tradingResponse?.decryptedData?.DATA?.leverage ||
                                         tradingResponse?.data?.DATA?.LEVERAGE ||
                                         tradingResponse?.data?.DATA?.leverage;
                    
                    if (leverageValue) {
                        const intValue = parseInt(leverageValue, 10);
                        if (!isNaN(intValue)) {
                            return intValue;
                        }
                    }
                } catch (error) {
                    // Continue to default value
                }
                
                // Only default to 100 if we can't get it from anywhere
                return 100; // Default leverage
            };

            const leverage = await getLeverage();

            // Build BODY object matching Flutter structure exactly
            const body = {
                EMAIL: email,
                DEFAULT_LEVERAGE: leverage,
                IS_CREATE: 0  // 0 for regulation API call, 1 for document upload
            };

            // USER_COMPANY
            const userCompany = {};
            if (name) userCompany.NAME = name;
            if (regNumber) userCompany.REG_NUMBER = regNumber;
            if (regDate) {
                const formattedDate = formatDate(regDate);
                if (formattedDate) userCompany.REG_DATE = formattedDate;
            }
            if (regAuthority) userCompany.REG_AUTHORITY = regAuthority;
            if (vat) userCompany.VAT = vat;
            if (lei) userCompany.LEI = lei;
            if (licenseNumber) userCompany.LICENSE_NUMBER = licenseNumber;
            if (licenseAuthority) userCompany.LICENSE_AUTHORITY = licenseAuthority;
            if (country) userCompany.COUNTRY = country;
            if (address) userCompany.ADDRESS = address;
            if (website) userCompany.WEBSITE = website;
            if (companyType) userCompany.COMPANY_TYPE = companyType;
            if (companyDescription) userCompany.COMPANY_DESCRIPTION = companyDescription;
            if (estimatedRevenue) {
                const revenue = toNumber(estimatedRevenue);
                if (revenue !== null) userCompany.ESTIMATED_REVENUE = revenue;
            }
            if (sourceOfFunds) userCompany.SOURCE_OF_FUNDS = sourceOfFunds;
            if (taxResidency) userCompany.TAX_RESIDENCY = taxResidency;
            if (sectorClassification) userCompany.SECTOR_CLASSIFICATION = sectorClassification;
            if (financialStatus) userCompany.FINANCIAL_STATUS = financialStatus;
            if (bankName) userCompany.BANK_NAME = bankName;
            if (opsPace) userCompany.OPS_PACE = opsPace;
            if (avgTxAmount) {
                const amount = toNumber(avgTxAmount);
                if (amount !== null) userCompany.AVG_TX_AMOUNT = amount;
            }
            if (expectedAnnualActivity) {
                const activity = toNumber(expectedAnnualActivity);
                if (activity !== null) userCompany.EXPECTED_ANNUAL_ACTIVITY = activity;
            }

            if (Object.keys(userCompany).length > 0) {
                body.USER_COMPANY = userCompany;
            }

            // ECONOMIC_OWNERS - Currently only number is collected, so we'll skip for now
            // If you need to collect individual economic owner data, you'd need to add form fields
            // For now, we'll only include if numberOfEconomicOwners > 0 and we have data
            // Since the form only collects the number, we'll leave this empty array or omit it

            // COMPLIANCE_OFFICER
            if (complianceOfficerFirstName || complianceOfficerLastName) {
                const complianceOfficer = buildEconomicSector({
                    firstName: complianceOfficerFirstName,
                    lastName: complianceOfficerLastName,
                    fathersName: complianceOfficerFathersName,
                    motherName: complianceOfficerMotherName,
                    gender: complianceOfficerGender,
                    regNumber: complianceOfficerRegNumber,
                    regPlace: complianceOfficerRegPlace,
                    idNumber: complianceOfficerIdNumber,
                    identificationImageId: null, // Would need image upload API
                    basedInLebanon: complianceOfficerBasedInLebanon,
                    hasOwnership: complianceOfficerHasOwnership,
                    ownedPercentage: complianceOfficerOwnedPercentage
                });
                if (Object.keys(complianceOfficer).length > 0) {
                    body.COMPLIANCE_OFFICER = complianceOfficer;
                }
            }

            // LEGAL_REPRESENTATIVE
            if (legalRepFirstName || legalRepLastName) {
                const legalRep = buildEconomicSector({
                    firstName: legalRepFirstName,
                    lastName: legalRepLastName,
                    fathersName: legalRepFathersName,
                    motherName: legalRepMotherName,
                    gender: legalRepGender,
                    regNumber: legalRepRegNumber,
                    regPlace: legalRepRegPlace,
                    idNumber: legalRepIdNumber,
                    identificationImageId: null, // Would need image upload API
                    basedInLebanon: legalRepBasedInLebanon,
                    hasOwnership: legalRepHasOwnership,
                    ownedPercentage: legalRepOwnedPercentage
                });
                if (Object.keys(legalRep).length > 0) {
                    body.LEGAL_REPRESENTATIVE = legalRep;
                }
            }

            // BOARD_CHAIRMAN
            if (boardChairmanFirstName || boardChairmanLastName) {
                const boardChairman = buildEconomicSector({
                    firstName: boardChairmanFirstName,
                    lastName: boardChairmanLastName,
                    fathersName: boardChairmanFathersName,
                    motherName: boardChairmanMotherName,
                    gender: boardChairmanGender,
                    regNumber: boardChairmanRegNumber,
                    regPlace: boardChairmanRegPlace,
                    idNumber: boardChairmanIdNumber,
                    identificationImageId: null, // Would need image upload API
                    basedInLebanon: boardChairmanBasedInLebanon,
                    hasOwnership: boardChairmanHasOwnership,
                    ownedPercentage: boardChairmanOwnedPercentage
                });
                if (Object.keys(boardChairman).length > 0) {
                    body.BOARD_CHAIRMAN = boardChairman;
                }
            }

            // USER_ENTITY_SHAREHOLDER - Map from Main Shareholder section
            if (mainShareholderFullName) {
                const userEntityShareholder = {
                    TYPE: 2, // 2 = Main Shareholder (EntityType.MAIN_SHAREHOLDER.value)
                    FULL_NAME: mainShareholderFullName
                };
                // NATIONALITY - only set if it's a valid non-empty value (required field)
                if (mainShareholderNationality && mainShareholderNationality.trim() !== "") {
                    userEntityShareholder.NATIONALITY = mainShareholderNationality.trim();
                } else {
                    // If validation passed but somehow empty, set to null (should not happen due to validation above)
                    userEntityShareholder.NATIONALITY = null;
                }
                // DATE_OF_BIRTH - required field
                if (mainShareholderDateOfBirth) {
                    const isoDate = formatDateToISO8601(mainShareholderDateOfBirth);
                    if (isoDate) userEntityShareholder.DATE_OF_BIRTH = isoDate;
                }
                // OWNERSHIP_PERCENTAGE - required field
                if (mainShareholderOwnershipPercentage && mainShareholderOwnershipPercentage.trim() !== "") {
                    const percentage = toNumber(mainShareholderOwnershipPercentage);
                    if (percentage !== null) {
                        userEntityShareholder.OWNERSHIP_PERCENTAGE = percentage;
                    }
                }
                // IS_PEP: boolean to 0/1 (matches Flutter)
                userEntityShareholder.IS_PEP = mainShareholderIsPep ? 1 : 0;
                // PHONE: Use beneficial right owner phone if available (matches Flutter pattern)
                if (beneficialRightOwnerMobilePhone && beneficialRightOwnerMobilePhone.trim() !== "") {
                    userEntityShareholder.PHONE = beneficialRightOwnerMobilePhone.trim();
                }
                body.USER_ENTITY_SHAREHOLDER = userEntityShareholder;
            }

            // USER_ENTITY_DIRECTOR - Map from Board of Directors section
            if (boardOfDirectorsFullName) {
                const userEntityDirector = {
                    TYPE: 1, // 1 = Board of Directors (EntityType.BOARD_OF_DIRECTORS.value)
                    FULL_NAME: boardOfDirectorsFullName
                };
                // NATIONALITY - only set if it's a valid non-empty value (required field)
                if (boardOfDirectorsNationality && boardOfDirectorsNationality.trim() !== "") {
                    userEntityDirector.NATIONALITY = boardOfDirectorsNationality.trim();
                } else {
                    // If validation passed but somehow empty, set to null (should not happen due to validation above)
                    userEntityDirector.NATIONALITY = null;
                }
                // DATE_OF_BIRTH - required field
                if (boardOfDirectorsDateOfBirth) {
                    const isoDate = formatDateToISO8601(boardOfDirectorsDateOfBirth);
                    if (isoDate) userEntityDirector.DATE_OF_BIRTH = isoDate;
                }
                // POSITION - required field
                if (boardOfDirectorsPosition && boardOfDirectorsPosition.trim() !== "") {
                    userEntityDirector.POSITION = boardOfDirectorsPosition.trim();
                }
                // OWNERSHIP_PERCENTAGE - required field
                if (boardOfDirectorsOwnerPercentage && boardOfDirectorsOwnerPercentage.trim() !== "") {
                    const percentage = toNumber(boardOfDirectorsOwnerPercentage);
                    if (percentage !== null) {
                        userEntityDirector.OWNERSHIP_PERCENTAGE = percentage;
                    }
                }
                // IS_PEP: boolean to 0/1 (matches Flutter)
                userEntityDirector.IS_PEP = boardOfDirectorsIsPep ? 1 : 0;
                body.USER_ENTITY_DIRECTOR = userEntityDirector;
            }

            // USER_ENTITY_BENEFICAL - Map from Beneficial Right Owner section (only if type is "other")
            if (beneficialRightOwnerType === "other" && beneficialRightOwnerFullName) {
                const userEntityBenefical = {
                    TYPE: 0, // 0 = Beneficial Right Owner
                    FULL_NAME: beneficialRightOwnerFullName
                };
                if (beneficialRightOwnerAddress) userEntityBenefical.ADDRESS = beneficialRightOwnerAddress;
                if (beneficialRightOwnerMobilePhone) userEntityBenefical.PHONE = beneficialRightOwnerMobilePhone;
                // Missing fields (set to defaults/null):
                userEntityBenefical.IS_PEP = 0; // Default to 0 (No)
                // DATE_OF_BIRTH, NATIONALITY, OWNERSHIP_PERCENTAGE, POSITION are not in form - set to null or omit
                body.USER_ENTITY_BENEFICAL = userEntityBenefical;
            }

            // ECONOMIC_OWNERS - Currently only number is collected
            // If numberOfEconomicOwners > 0, we'd need individual forms for each owner
            // For now, we'll omit the array if we don't have individual data
            // Note: Flutter sends empty array if no owners, but we'll omit the field entirely

            // AUTHORIZED_SIGNATORIES - Currently only number is collected
            // Similar to ECONOMIC_OWNERS, we'll omit for now unless you add individual fields

            // Ensure IS_CREATE is explicitly set to 0 for regulation API (not document upload)
            body.IS_CREATE = 0;


            // Step 1: Call the regulation API
            const response = await createRegulationCompanyMT5Account(body);

            // Handle response
            const responseData = response.decryptedData || response.data || response;
            const code = responseData.CODE || responseData.code || responseData.status;

            if (code === AppConstants.responseOk) {
                // Step 2: Upload documents (Main Shareholder + Board of Directors + Company Documents)
                // This matches Flutter's flow: regulation first, then documents
                const hasDocumentsToUpload = 
                    mainShareholderFrontImage || 
                    mainShareholderBackImage || 
                    mainShareholderMainImage ||
                    boardOfDirectorsFrontImage || 
                    boardOfDirectorsBackImage || 
                    boardOfDirectorsMainImage ||
                    companyDocumentArticleOfIncorporation ||
                    companyDocumentCommercialRegistration ||
                    companyDocumentCommercialCircular;
                
                if (hasDocumentsToUpload) {
                    try {
                        const documentsResponse = await uploadCompanyDocuments(email);
                        const documentsResponseData = documentsResponse.decryptedData || documentsResponse.data || documentsResponse;
                        const documentsCode = documentsResponseData.CODE || documentsResponseData.code || documentsResponseData.status;

                        if (documentsCode !== AppConstants.responseOk) {
                            // Documents upload failed, but regulation succeeded
                            // Still navigate - documents can be uploaded later if needed
                        }
                    } catch (documentsError) {
                        // Documents upload failed, but regulation succeeded
                        // Still navigate - documents can be uploaded later if needed
                    }
                }

                // Success - navigate to next page
                navigate("/urban-info");
            } else {
                // Error handling
                const errorMessage = responseData.MESSAGE || responseData.message || responseData.ERROR || responseData.error || 
                    t("companyRegulation.errors.submitFailed") || "Failed to submit company regulation. Please try again.";
                setErrorPopupMessage(errorMessage);
                setShowErrorPopup(true);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 
                t("companyRegulation.errors.submitFailed") || "An error occurred while submitting. Please try again.";
            setErrorPopupMessage(errorMessage);
            setShowErrorPopup(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="company-regulation-page">
            {showErrorPopup && (
                <Popup
                    message={errorPopupMessage}
                    onClose={() => setShowErrorPopup(false)}
                />
            )}
            <CustomCard className="company-regulation-card">
                <div className="company-regulation-inner">
                    <div className="signup-content company-regulation-content">
                        <h1 className="signup-title">
                            {t("companyRegulation.title") || "Company Regulation"}
                        </h1>

                        {/* Progress - Only step 1 active */}
                        <div className="progress-indicator">
                            <div className="progress-circle active">
                                {t("companyRegulation.progress.step1") || "01"}
                            </div>
                            <div className="progress-line" />
                            <div className="progress-circle">
                                {t("companyRegulation.progress.step2") || "02"}
                            </div>
                            <div className="progress-line" />
                            <div className="progress-circle">
                                {t("companyRegulation.progress.step3") || "03"}
                            </div>
                        </div>

                        <div className="signup-form company-regulation-grid">
                            {/* Company */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.company") || "Company"}
                                </h2>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.company.name") || "Company Name"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-building"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className={`input-box ${fieldErrors.name ? "input-error" : ""}`}
                                            placeholder="Company Name"
                                            value={name}
                                            onChange={(e) => { setName(e.target.value); if (fieldErrors.name) setFieldErrors(prev => ({...prev, name: null})); }}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.registrationNumber") || "Registration Number"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-hashtag"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.regNumber ? "input-error" : ""}`}
                                                placeholder="Registration Number"
                                                value={regNumber}
                                                onChange={(e) => { setRegNumber(e.target.value); if (fieldErrors.regNumber) setFieldErrors(prev => ({...prev, regNumber: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.regDate") || "Registration Date"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-calendar"></i>
                                            </span>
                                            <input
                                                type="date"
                                                className={`input-box ${fieldErrors.regDate ? "input-error" : ""}`}
                                                value={regDate}
                                                onChange={(e) => { setRegDate(e.target.value); if (fieldErrors.regDate) setFieldErrors(prev => ({...prev, regDate: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.regAuthority") || "Registration Authority"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-gavel"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.regAuthority ? "input-error" : ""}`}
                                                placeholder="Registration Authority"
                                                value={regAuthority}
                                                onChange={(e) => { setRegAuthority(e.target.value); if (fieldErrors.regAuthority) setFieldErrors(prev => ({...prev, regAuthority: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.companyType") || "Company Type"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-briefcase"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.companyType ? "input-error" : ""}`}
                                                placeholder="Company Type"
                                                value={companyType}
                                                onChange={(e) => { setCompanyType(e.target.value); if (fieldErrors.companyType) setFieldErrors(prev => ({...prev, companyType: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.lei") || "LEI"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-id-card"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.lei ? "input-error" : ""}`}
                                                placeholder="LEI"
                                                value={lei}
                                                onChange={(e) => { setLei(e.target.value); if (fieldErrors.lei) setFieldErrors(prev => ({...prev, lei: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.country") || "Country"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={countryOptions}
                                                    value={
                                                        country
                                                            ? {
                                                                value: country,
                                                                label:
                                                                    countryOptions.find((opt) => opt.value === country)?.label ||
                                                                    country,
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setCountry(selected ? selected.value : "");
                                                        if (fieldErrors.country) setFieldErrors(prev => ({...prev, country: null}));
                                                    }}
                                                    placeholder={t("urbanInfo.country.placeholder") || "Select country"}
                                                    searchable={true}
                                                    className={fieldErrors.country ? "dropdown-error" : ""}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.licenseAuthority") || "License Authority"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-certificate"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.licenseAuthority ? "input-error" : ""}`}
                                                placeholder="License Authority"
                                                value={licenseAuthority}
                                                onChange={(e) => { setLicenseAuthority(e.target.value); if (fieldErrors.licenseAuthority) setFieldErrors(prev => ({...prev, licenseAuthority: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.licenseNumber") || "License Number"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-id-badge"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.licenseNumber ? "input-error" : ""}`}
                                                placeholder="License Number"
                                                value={licenseNumber}
                                                onChange={(e) => { setLicenseNumber(e.target.value); if (fieldErrors.licenseNumber) setFieldErrors(prev => ({...prev, licenseNumber: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.company.address") || "Address"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-map-marker-alt"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className={`input-box ${fieldErrors.address ? "input-error" : ""}`}
                                            placeholder="Company Address"
                                            value={address}
                                            onChange={(e) => { setAddress(e.target.value); if (fieldErrors.address) setFieldErrors(prev => ({...prev, address: null})); }}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.company.website") || "Website"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-globe"></i>
                                        </span>
                                        <input
                                            type="url"
                                            className={`input-box ${fieldErrors.website ? "input-error" : ""}`}
                                            placeholder="Website"
                                            value={website}
                                            onChange={(e) => { setWebsite(e.target.value); if (fieldErrors.website) setFieldErrors(prev => ({...prev, website: null})); }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.company.companyDescription") || "Company Description"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-file-text"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className={`input-box ${fieldErrors.companyDescription ? "input-error" : ""}`}
                                            placeholder="Company Description"
                                            value={companyDescription}
                                            onChange={(e) => { setCompanyDescription(e.target.value); if (fieldErrors.companyDescription) setFieldErrors(prev => ({...prev, companyDescription: null})); }}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.vat") || "VAT Number"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-receipt"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.vat ? "input-error" : ""}`}
                                                placeholder="Vat Number"
                                                value={vat}
                                                onChange={(e) => { setVat(e.target.value); if (fieldErrors.vat) setFieldErrors(prev => ({...prev, vat: null})); }}
                                            />
                                        </div>
                                    </div>


                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.estimatedRevenue") || "Estimated Annual Revenue"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-dollar-sign"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className={`input-box ${fieldErrors.estimatedRevenue ? "input-error" : ""}`}
                                                placeholder="Revenue"
                                                value={estimatedRevenue}
                                                onChange={(e) => { setEstimatedRevenue(e.target.value); if (fieldErrors.estimatedRevenue) setFieldErrors(prev => ({...prev, estimatedRevenue: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.sourceOfFunds") || "Source of Funds"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-money-bill-wave"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.sourceOfFunds ? "input-error" : ""}`}
                                                placeholder="Investments"
                                                value={sourceOfFunds}
                                                onChange={(e) => { setSourceOfFunds(e.target.value); if (fieldErrors.sourceOfFunds) setFieldErrors(prev => ({...prev, sourceOfFunds: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.taxResidency") || "Tax Residency"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-landmark"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.taxResidency ? "input-error" : ""}`}
                                                placeholder="Tax Residency"
                                                value={taxResidency}
                                                onChange={(e) => { setTaxResidency(e.target.value); if (fieldErrors.taxResidency) setFieldErrors(prev => ({...prev, taxResidency: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.sectorClassification") || "Sector Classification"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-layer-group"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.sectorClassification ? "input-error" : ""}`}
                                                placeholder="Sector Classification"
                                                value={sectorClassification}
                                                onChange={(e) => { setSectorClassification(e.target.value); if (fieldErrors.sectorClassification) setFieldErrors(prev => ({...prev, sectorClassification: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.financialStatus") || "Financial Status"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-chart-line"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.financialStatus ? "input-error" : ""}`}
                                                placeholder="Financial Status"
                                                value={financialStatus}
                                                onChange={(e) => { setFinancialStatus(e.target.value); if (fieldErrors.financialStatus) setFieldErrors(prev => ({...prev, financialStatus: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.bankName") || "Bank Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-university"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.bankName ? "input-error" : ""}`}
                                                placeholder="Bank Name"
                                                value={bankName}
                                                onChange={(e) => { setBankName(e.target.value); if (fieldErrors.bankName) setFieldErrors(prev => ({...prev, bankName: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.opsPace") || "Operations Pace"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-tachometer-alt"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className={`input-box ${fieldErrors.opsPace ? "input-error" : ""}`}
                                                placeholder="Operations Pace"
                                                value={opsPace}
                                                onChange={(e) => { setOpsPace(e.target.value); if (fieldErrors.opsPace) setFieldErrors(prev => ({...prev, opsPace: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.avgTxAmount") || "Average Transaction Amount"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-exchange-alt"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className={`input-box ${fieldErrors.avgTxAmount ? "input-error" : ""}`}
                                                placeholder="Transaction Amount"
                                                value={avgTxAmount}
                                                onChange={(e) => { setAvgTxAmount(e.target.value); if (fieldErrors.avgTxAmount) setFieldErrors(prev => ({...prev, avgTxAmount: null})); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.company.expectedAnnualActivity") || "Expected Annual Activity"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-calendar-alt"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className={`input-box ${fieldErrors.expectedAnnualActivity ? "input-error" : ""}`}
                                                placeholder="Annual Activity"
                                                value={expectedAnnualActivity}
                                                onChange={(e) => { setExpectedAnnualActivity(e.target.value); if (fieldErrors.expectedAnnualActivity) setFieldErrors(prev => ({...prev, expectedAnnualActivity: null})); }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Economic Owners */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.economicOwners") ||
                                        "Economic Owners"}
                                </h2>
                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.economicOwners.numberOfEconomicOwners") || "Number of Economic Owners"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-users"></i>
                                        </span>
                                        <input
                                            type="number"
                                            className={`input-box ${fieldErrors.numberOfEconomicOwners ? "input-error" : ""}`}
                                            placeholder="Number of Economic Owners"
                                            min="0"
                                            value={numberOfEconomicOwners}
                                            onChange={(e) => { setNumberOfEconomicOwners(e.target.value); if (fieldErrors.numberOfEconomicOwners) setFieldErrors(prev => ({...prev, numberOfEconomicOwners: null})); }}
                                        />
                                    </div>
                                </div>
                            </section>

                            {/* Compliance Officer */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.complianceOfficer") ||
                                        "Compliance Officer"}
                                </h2>
                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.complianceOfficer.firstName") || "First Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="First Name"
                                                value={complianceOfficerFirstName}
                                                onChange={(e) => setComplianceOfficerFirstName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.complianceOfficer.lastName") || "Last Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Last Name"
                                                value={complianceOfficerLastName}
                                                onChange={(e) => setComplianceOfficerLastName(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.complianceOfficer.fathersName") || "Father's Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user-tie"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Father's Name"
                                                value={complianceOfficerFathersName}
                                                onChange={(e) => setComplianceOfficerFathersName(e.target.value)}
                                            />
                                        </div>

                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.complianceOfficer.motherName") || "Mother's Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Mother's Name"
                                                value={complianceOfficerMotherName}
                                                onChange={(e) => setComplianceOfficerMotherName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>






                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.complianceOfficer.gender") || "Gender"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={[
                                                        { value: 0, label: t("personalInformation.gender.options.male") || "Male" },
                                                        { value: 1, label: t("personalInformation.gender.options.female") || "Female" },
                                                    ]}
                                                    value={
                                                        complianceOfficerGender !== null && complianceOfficerGender !== undefined
                                                            ? {
                                                                value: complianceOfficerGender,
                                                                label:
                                                                    complianceOfficerGender === 0
                                                                        ? t("personalInformation.gender.options.male") || "Male"
                                                                        : t("personalInformation.gender.options.female") || "Female",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setComplianceOfficerGender(selected ? selected.value : null);
                                                    }}
                                                    placeholder={t("personalInformation.placeholders.selectGender") || "Select Gender"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.complianceOfficer.regNumber") || "Registration Number"}</label>
                                        <div className="input-wrapper">
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Registration Number"
                                                value={complianceOfficerRegNumber}
                                                onChange={(e) => setComplianceOfficerRegNumber(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-12">
                                        <label>{t("companyRegulation.labels.complianceOfficer.regPlace") || "Registration Place"}</label>
                                        <div className="input-wrapper">
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Registration Place"
                                                value={complianceOfficerRegPlace}
                                                onChange={(e) => setComplianceOfficerRegPlace(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                </div>





                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.complianceOfficer.idNumber") || "ID Number"}</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="text"
                                            className="input-box"
                                            placeholder="ID Number"
                                            value={complianceOfficerIdNumber}
                                            onChange={(e) => setComplianceOfficerIdNumber(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.complianceOfficer.identificationImage") || "Identification Image"}</label>
                                    <div className="file-upload-wrapper">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    setComplianceOfficerIdentificationImage(file);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setComplianceOfficerIdentificationImagePreview(reader.result);
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }}
                                            className="file-input"
                                            id="complianceOfficerIdentificationImageInput"
                                        />
                                        <label htmlFor="complianceOfficerIdentificationImageInput" className="file-upload-area">
                                            {complianceOfficerIdentificationImagePreview ? (
                                                <div className="image-preview-container">
                                                    <img
                                                        src={complianceOfficerIdentificationImagePreview}
                                                        alt={t("companyRegulation.labels.complianceOfficer.identificationImage") || "Identification preview"}
                                                        className="uploaded-image"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setComplianceOfficerIdentificationImage(null);
                                                            setComplianceOfficerIdentificationImagePreview(null);
                                                            const input = document.getElementById("complianceOfficerIdentificationImageInput");
                                                            if (input) input.value = "";
                                                        }}
                                                        className="remove-image-btn"
                                                        aria-label="Remove image"
                                                    >
                                                        <i className="fa-solid fa-times"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle change-image-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById("complianceOfficerIdentificationImageInput")?.click();
                                                        }}
                                                        aria-label="Change image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="camera-icon-placeholder">
                                                        <i className="fa-solid fa-camera"></i>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("complianceOfficerIdentificationImageInput")?.click();
                                                        }}
                                                        aria-label="Upload image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                    <span className="document-image-text">
                                                        {t("companyRegulation.labels.complianceOfficer.identificationImage") || "Identification Image"}
                                                    </span>
                                                </>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={complianceOfficerBasedInLebanon === 1}
                                            onChange={(e) => setComplianceOfficerBasedInLebanon(e.target.checked ? 1 : 0)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setComplianceOfficerBasedInLebanon(complianceOfficerBasedInLebanon === 1 ? 0 : 1)}>
                                            {t("companyRegulation.labels.complianceOfficer.basedInLebanon") || "Based in Lebanon"}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={complianceOfficerHasOwnership === 1}
                                            onChange={(e) => setComplianceOfficerHasOwnership(e.target.checked ? 1 : 0)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setComplianceOfficerHasOwnership(complianceOfficerHasOwnership === 1 ? 0 : 1)}>
                                            {t("companyRegulation.labels.complianceOfficer.hasOwnership") || "Has Ownership"}
                                        </label>
                                    </div>
                                </div>

                                {complianceOfficerHasOwnership === 1 && (
                                    <div className="form-group">
                                        <label>{t("companyRegulation.labels.complianceOfficer.ownedPercentage") || "Owned Percentage"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-percent"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className="input-box"
                                                placeholder="0"
                                                min="0"
                                                max="100"
                                                value={complianceOfficerOwnedPercentage}
                                                onChange={(e) => setComplianceOfficerOwnedPercentage(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                )}
                            </section>

                            {/* Legal Representative */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.legalRepresentative") ||
                                        "Legal Representative"}
                                </h2>
                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.legalRepresentative.firstName") || "First Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="First Name"
                                                value={legalRepFirstName}
                                                onChange={(e) => setLegalRepFirstName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.legalRepresentative.lastName") || "Last Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Last Name"
                                                value={legalRepLastName}
                                                onChange={(e) => setLegalRepLastName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.legalRepresentative.fathersName") || "Father's Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user-tie"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Father's Name"
                                                value={legalRepFathersName}
                                                onChange={(e) => setLegalRepFathersName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.legalRepresentative.motherName") || "Mother's Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Mother's Name"
                                                value={legalRepMotherName}
                                                onChange={(e) => setLegalRepMotherName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.legalRepresentative.gender") || "Gender"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={[
                                                        { value: 0, label: t("personalInformation.gender.options.male") || "Male" },
                                                        { value: 1, label: t("personalInformation.gender.options.female") || "Female" },
                                                    ]}
                                                    value={
                                                        legalRepGender !== null && legalRepGender !== undefined
                                                            ? {
                                                                value: legalRepGender,
                                                                label:
                                                                    legalRepGender === 0
                                                                        ? t("personalInformation.gender.options.male") || "Male"
                                                                        : t("personalInformation.gender.options.female") || "Female",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setLegalRepGender(selected ? selected.value : null);
                                                    }}
                                                    placeholder={t("personalInformation.placeholders.selectGender") || "Select Gender"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.legalRepresentative.regNumber") || "Registration Number"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-hashtag"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Registration Number"
                                                value={legalRepRegNumber}
                                                onChange={(e) => setLegalRepRegNumber(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-12">
                                        <label>{t("companyRegulation.labels.legalRepresentative.regPlace") || "Registration Place"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-map-marker-alt"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Registration Place"
                                                value={legalRepRegPlace}
                                                onChange={(e) => setLegalRepRegPlace(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.legalRepresentative.idNumber") || "ID Number"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-id-card"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className="input-box"
                                            placeholder="ID Number"
                                            value={legalRepIdNumber}
                                            onChange={(e) => setLegalRepIdNumber(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.legalRepresentative.identificationImage") || "Identification Image"}</label>
                                    <div className="file-upload-wrapper">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    setLegalRepIdentificationImage(file);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setLegalRepIdentificationImagePreview(reader.result);
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }}
                                            className="file-input"
                                            id="legalRepIdentificationImageInput"
                                        />
                                        <label htmlFor="legalRepIdentificationImageInput" className="file-upload-area">
                                            {legalRepIdentificationImagePreview ? (
                                                <div className="image-preview-container">
                                                    <img
                                                        src={legalRepIdentificationImagePreview}
                                                        alt={t("companyRegulation.labels.legalRepresentative.identificationImage") || "Identification preview"}
                                                        className="uploaded-image"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setLegalRepIdentificationImage(null);
                                                            setLegalRepIdentificationImagePreview(null);
                                                            const input = document.getElementById("legalRepIdentificationImageInput");
                                                            if (input) input.value = "";
                                                        }}
                                                        className="remove-image-btn"
                                                        aria-label="Remove image"
                                                    >
                                                        <i className="fa-solid fa-times"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle change-image-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById("legalRepIdentificationImageInput")?.click();
                                                        }}
                                                        aria-label="Change image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="camera-icon-placeholder">
                                                        <i className="fa-solid fa-camera"></i>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("legalRepIdentificationImageInput")?.click();
                                                        }}
                                                        aria-label="Upload image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                    <span className="document-image-text">
                                                        {t("companyRegulation.labels.legalRepresentative.identificationImage") || "Identification Image"}
                                                    </span>
                                                </>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={legalRepBasedInLebanon === 1}
                                            onChange={(e) => setLegalRepBasedInLebanon(e.target.checked ? 1 : 0)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setLegalRepBasedInLebanon(legalRepBasedInLebanon === 1 ? 0 : 1)}>
                                            {t("companyRegulation.labels.legalRepresentative.basedInLebanon") || "Based in Lebanon"}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={legalRepHasOwnership === 1}
                                            onChange={(e) => setLegalRepHasOwnership(e.target.checked ? 1 : 0)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setLegalRepHasOwnership(legalRepHasOwnership === 1 ? 0 : 1)}>
                                            {t("companyRegulation.labels.legalRepresentative.hasOwnership") || "Has Ownership"}
                                        </label>
                                    </div>
                                </div>

                                {legalRepHasOwnership === 1 && (
                                    <div className="form-group">
                                        <label>{t("companyRegulation.labels.legalRepresentative.ownedPercentage") || "Owned Percentage"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-percent"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className="input-box"
                                                placeholder="0"
                                                min="0"
                                                max="100"
                                                value={legalRepOwnedPercentage}
                                                onChange={(e) => setLegalRepOwnedPercentage(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                )}
                            </section>

                            {/* Board Chairman */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.boardChairman") ||
                                        "Board Chairman"}
                                </h2>
                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardChairman.firstName") || "First Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="First Name"
                                                value={boardChairmanFirstName}
                                                onChange={(e) => setBoardChairmanFirstName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardChairman.lastName") || "Last Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Last Name"
                                                value={boardChairmanLastName}
                                                onChange={(e) => setBoardChairmanLastName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardChairman.fathersName") || "Father's Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user-tie"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Father's Name"
                                                value={boardChairmanFathersName}
                                                onChange={(e) => setBoardChairmanFathersName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardChairman.motherName") || "Mother's Name"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-user"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Mother's Name"
                                                value={boardChairmanMotherName}
                                                onChange={(e) => setBoardChairmanMotherName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardChairman.gender") || "Gender"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={[
                                                        { value: 0, label: t("personalInformation.gender.options.male") || "Male" },
                                                        { value: 1, label: t("personalInformation.gender.options.female") || "Female" },
                                                    ]}
                                                    value={
                                                        boardChairmanGender !== null && boardChairmanGender !== undefined
                                                            ? {
                                                                value: boardChairmanGender,
                                                                label:
                                                                    boardChairmanGender === 0
                                                                        ? t("personalInformation.gender.options.male") || "Male"
                                                                        : t("personalInformation.gender.options.female") || "Female",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setBoardChairmanGender(selected ? selected.value : null);
                                                    }}
                                                    placeholder={t("personalInformation.placeholders.selectGender") || "Select Gender"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardChairman.regNumber") || "Registration Number"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-hashtag"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Registration Number"
                                                value={boardChairmanRegNumber}
                                                onChange={(e) => setBoardChairmanRegNumber(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-12">
                                        <label>{t("companyRegulation.labels.boardChairman.regPlace") || "Registration Place"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-map-marker-alt"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder="Registration Place"
                                                value={boardChairmanRegPlace}
                                                onChange={(e) => setBoardChairmanRegPlace(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.boardChairman.idNumber") || "ID Number"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-id-card"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className="input-box"
                                            placeholder="ID Number"
                                            value={boardChairmanIdNumber}
                                            onChange={(e) => setBoardChairmanIdNumber(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.boardChairman.identificationImage") || "Identification Image"}</label>
                                    <div className="file-upload-wrapper">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    setBoardChairmanIdentificationImage(file);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setBoardChairmanIdentificationImagePreview(reader.result);
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }}
                                            className="file-input"
                                            id="boardChairmanIdentificationImageInput"
                                        />
                                        <label htmlFor="boardChairmanIdentificationImageInput" className="file-upload-area">
                                            {boardChairmanIdentificationImagePreview ? (
                                                <div className="image-preview-container">
                                                    <img
                                                        src={boardChairmanIdentificationImagePreview}
                                                        alt={t("companyRegulation.labels.boardChairman.identificationImage") || "Identification preview"}
                                                        className="uploaded-image"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setBoardChairmanIdentificationImage(null);
                                                            setBoardChairmanIdentificationImagePreview(null);
                                                            const input = document.getElementById("boardChairmanIdentificationImageInput");
                                                            if (input) input.value = "";
                                                        }}
                                                        className="remove-image-btn"
                                                        aria-label="Remove image"
                                                    >
                                                        <i className="fa-solid fa-times"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle change-image-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById("boardChairmanIdentificationImageInput")?.click();
                                                        }}
                                                        aria-label="Change image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="camera-icon-placeholder">
                                                        <i className="fa-solid fa-camera"></i>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("boardChairmanIdentificationImageInput")?.click();
                                                        }}
                                                        aria-label="Upload image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                    <span className="document-image-text">
                                                        {t("companyRegulation.labels.boardChairman.identificationImage") || "Identification Image"}
                                                    </span>
                                                </>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={boardChairmanBasedInLebanon === 1}
                                            onChange={(e) => setBoardChairmanBasedInLebanon(e.target.checked ? 1 : 0)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setBoardChairmanBasedInLebanon(boardChairmanBasedInLebanon === 1 ? 0 : 1)}>
                                            {t("companyRegulation.labels.boardChairman.basedInLebanon") || "Based in Lebanon"}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={boardChairmanHasOwnership === 1}
                                            onChange={(e) => setBoardChairmanHasOwnership(e.target.checked ? 1 : 0)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setBoardChairmanHasOwnership(boardChairmanHasOwnership === 1 ? 0 : 1)}>
                                            {t("companyRegulation.labels.boardChairman.hasOwnership") || "Has Ownership"}
                                        </label>
                                    </div>
                                </div>

                                {boardChairmanHasOwnership === 1 && (
                                    <div className="form-group">
                                        <label>{t("companyRegulation.labels.boardChairman.ownedPercentage") || "Owned Percentage"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-percent"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className="input-box"
                                                placeholder="0"
                                                min="0"
                                                max="100"
                                                value={boardChairmanOwnedPercentage}
                                                onChange={(e) => setBoardChairmanOwnedPercentage(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                )}
                            </section>

                            {/* Main Shareholders (Above 20%) */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.mainShareholder") || "Main Shareholders (Above 20%)"}
                                </h2>
                                
                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.mainShareholder.fullName") || "Shareholder Full Name"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-user"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className="input-box"
                                            placeholder={t("companyRegulation.placeholders.mainShareholder.fullName") || "Please enter the shareholder's full name"}
                                            value={mainShareholderFullName}
                                            onChange={(e) => setMainShareholderFullName(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.mainShareholder.nationality") || "Shareholder Nationality"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={countryOptions}
                                                    value={
                                                        mainShareholderNationality
                                                            ? {
                                                                value: mainShareholderNationality,
                                                                label:
                                                                    countryOptions.find((opt) => opt.value === mainShareholderNationality)?.label ||
                                                                    mainShareholderNationality,
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setMainShareholderNationality(selected ? selected.value : "");
                                                    }}
                                                    placeholder={t("companyRegulation.placeholders.mainShareholder.nationality") || "Select Nationality"}
                                                    searchable={true}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.mainShareholder.dateOfBirth") || "Shareholder Date of Birth"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-calendar"></i>
                                            </span>
                                            <input
                                                type="date"
                                                className="input-box"
                                                value={mainShareholderDateOfBirth}
                                                onChange={(e) => setMainShareholderDateOfBirth(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.mainShareholder.ownershipPercentage") || "Ownership Percentage"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-percent"></i>
                                            </span>
                                            <input
                                                type="number"
                                                className="input-box"
                                                placeholder={t("companyRegulation.placeholders.mainShareholder.ownershipPercentage") || "Enter ownership percentage"}
                                                min="20"
                                                value={mainShareholderOwnershipPercentage}
                                                onChange={(e) => setMainShareholderOwnershipPercentage(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.mainShareholder.documentType") || "Document Type"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={[
                                                        { value: 0, label: t("companyRegulation.labels.mainShareholder.documentTypeOptions.idCard") || "ID CARD" },
                                                        { value: 1, label: t("companyRegulation.labels.mainShareholder.documentTypeOptions.passport") || "PASSPORT" },
                                                    ]}
                                                    value={
                                                        mainShareholderDocumentType !== null && mainShareholderDocumentType !== undefined
                                                            ? {
                                                                value: mainShareholderDocumentType,
                                                                label:
                                                                    mainShareholderDocumentType === 0
                                                                        ? t("companyRegulation.labels.mainShareholder.documentTypeOptions.idCard") || "ID CARD"
                                                                        : t("companyRegulation.labels.mainShareholder.documentTypeOptions.passport") || "PASSPORT",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setMainShareholderDocumentType(selected ? selected.value : null);
                                                        if (selected?.value === 1) {
                                                            setMainShareholderFrontImage(null);
                                                            setMainShareholderFrontImagePreview(null);
                                                            setMainShareholderBackImage(null);
                                                            setMainShareholderBackImagePreview(null);
                                                        } else if (selected?.value === 0) {
                                                            setMainShareholderMainImage(null);
                                                            setMainShareholderMainImagePreview(null);
                                                        }
                                                    }}
                                                    placeholder={t("companyRegulation.placeholders.mainShareholder.documentType") || "Select Document Type"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ID CARD Images (Front and Back) */}
                                {mainShareholderDocumentType === 0 && (
                                    <>
                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.mainShareholder.frontImage") || "ID Front"}</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (file) {
                                                            setMainShareholderFrontImage(file);
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setMainShareholderFrontImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                    className="file-input"
                                                    id="mainShareholderFrontImageInput"
                                                />
                                                <label htmlFor="mainShareholderFrontImageInput" className="file-upload-area">
                                                    {mainShareholderFrontImagePreview ? (
                                                        <div className="image-preview-container">
                                                            <img
                                                                src={mainShareholderFrontImagePreview}
                                                                alt={t("companyRegulation.labels.mainShareholder.frontImage") || "ID Front preview"}
                                                                className="uploaded-image"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setMainShareholderFrontImage(null);
                                                                    setMainShareholderFrontImagePreview(null);
                                                                    const input = document.getElementById("mainShareholderFrontImageInput");
                                                                    if (input) input.value = "";
                                                                }}
                                                                className="remove-image-btn"
                                                                aria-label="Remove image"
                                                            >
                                                                <i className="fa-solid fa-times"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle change-image-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById("mainShareholderFrontImageInput")?.click();
                                                                }}
                                                                aria-label="Change image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="camera-icon-placeholder">
                                                                <i className="fa-solid fa-camera"></i>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    document.getElementById("mainShareholderFrontImageInput")?.click();
                                                                }}
                                                                aria-label="Upload image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                            <span className="document-image-text">
                                                                {t("companyRegulation.labels.mainShareholder.frontImage") || "ID Front"}
                                                            </span>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.mainShareholder.backImage") || "ID Back"}</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (file) {
                                                            setMainShareholderBackImage(file);
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setMainShareholderBackImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                    className="file-input"
                                                    id="mainShareholderBackImageInput"
                                                />
                                                <label htmlFor="mainShareholderBackImageInput" className="file-upload-area">
                                                    {mainShareholderBackImagePreview ? (
                                                        <div className="image-preview-container">
                                                            <img
                                                                src={mainShareholderBackImagePreview}
                                                                alt={t("companyRegulation.labels.mainShareholder.backImage") || "ID Back preview"}
                                                                className="uploaded-image"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setMainShareholderBackImage(null);
                                                                    setMainShareholderBackImagePreview(null);
                                                                    const input = document.getElementById("mainShareholderBackImageInput");
                                                                    if (input) input.value = "";
                                                                }}
                                                                className="remove-image-btn"
                                                                aria-label="Remove image"
                                                            >
                                                                <i className="fa-solid fa-times"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle change-image-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById("mainShareholderBackImageInput")?.click();
                                                                }}
                                                                aria-label="Change image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="camera-icon-placeholder">
                                                                <i className="fa-solid fa-camera"></i>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    document.getElementById("mainShareholderBackImageInput")?.click();
                                                                }}
                                                                aria-label="Upload image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                            <span className="document-image-text">
                                                                {t("companyRegulation.labels.mainShareholder.backImage") || "ID Back"}
                                                            </span>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* PASSPORT Image (Main Image) */}
                                {mainShareholderDocumentType === 1 && (
                                    <div className="form-group">
                                        <label>{t("companyRegulation.labels.mainShareholder.mainImage") || "Main Image"}</label>
                                        <div className="file-upload-wrapper">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const file = e.target.files?.[0];
                                                    if (file) {
                                                        setMainShareholderMainImage(file);
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => {
                                                            setMainShareholderMainImagePreview(reader.result);
                                                        };
                                                        reader.readAsDataURL(file);
                                                    }
                                                }}
                                                className="file-input"
                                                id="mainShareholderMainImageInput"
                                            />
                                            <label htmlFor="mainShareholderMainImageInput" className="file-upload-area">
                                                {mainShareholderMainImagePreview ? (
                                                    <div className="image-preview-container">
                                                        <img
                                                            src={mainShareholderMainImagePreview}
                                                            alt={t("companyRegulation.labels.mainShareholder.mainImage") || "Main image preview"}
                                                            className="uploaded-image"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setMainShareholderMainImage(null);
                                                                setMainShareholderMainImagePreview(null);
                                                                const input = document.getElementById("mainShareholderMainImageInput");
                                                                if (input) input.value = "";
                                                            }}
                                                            className="remove-image-btn"
                                                            aria-label="Remove image"
                                                        >
                                                            <i className="fa-solid fa-times"></i>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="upload-button-circle change-image-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                document.getElementById("mainShareholderMainImageInput")?.click();
                                                            }}
                                                            aria-label="Change image"
                                                        >
                                                            <i className="fa-solid fa-camera"></i>
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="camera-icon-placeholder">
                                                            <i className="fa-solid fa-camera"></i>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className="upload-button-circle"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                document.getElementById("mainShareholderMainImageInput")?.click();
                                                            }}
                                                            aria-label="Upload image"
                                                        >
                                                            <i className="fa-solid fa-camera"></i>
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                        <span className="document-image-text">
                                                            {t("companyRegulation.labels.mainShareholder.mainImage") || "Main Page"}
                                                        </span>
                                                    </>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                )}

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={mainShareholderIsPep}
                                            onChange={(e) => setMainShareholderIsPep(e.target.checked)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setMainShareholderIsPep(!mainShareholderIsPep)}>
                                            {t("companyRegulation.labels.mainShareholder.isPep") || "Are you a Politically Exposed Person or a Relative or Close Associate of a PEP?"}
                                        </label>
                                    </div>
                                </div>
                            </section>

                            {/* Authorized Signatories */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.authorizedSignatories") ||
                                        "Authorized Signatories"}
                                </h2>
                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.authorizedSignatories.numberOfAuthorizedSignatories") || "Number of Authorized Signatories"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-signature"></i>
                                        </span>
                                        <input
                                            type="number"
                                            className={`input-box ${fieldErrors.numberOfAuthorizedSignatories ? "input-error" : ""}`}
                                            placeholder="Number of Authorized Signatories"
                                            min="0"
                                            value={numberOfAuthorizedSignatories}
                                            onChange={(e) => { setNumberOfAuthorizedSignatories(e.target.value); if (fieldErrors.numberOfAuthorizedSignatories) setFieldErrors(prev => ({...prev, numberOfAuthorizedSignatories: null})); }}
                                        />
                                    </div>
                                </div>
                            </section>

                            {/* Board of Directors */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.boardOfDirectors") ||
                                        "Board of Directors"}
                                </h2>
                                
                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.boardOfDirectors.fullName") || "Director Full Name"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-user"></i>
                                        </span>
                                        <input
                                            type="text"
                                            className="input-box"
                                            placeholder={t("companyRegulation.placeholders.boardOfDirectors.fullName") || "Please enter the director's full name"}
                                            value={boardOfDirectorsFullName}
                                            onChange={(e) => setBoardOfDirectorsFullName(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardOfDirectors.nationality") || "Director Nationality"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={countryOptions}
                                                    value={
                                                        boardOfDirectorsNationality
                                                            ? {
                                                                value: boardOfDirectorsNationality,
                                                                label:
                                                                    countryOptions.find((opt) => opt.value === boardOfDirectorsNationality)?.label ||
                                                                    boardOfDirectorsNationality,
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setBoardOfDirectorsNationality(selected ? selected.value : "");
                                                    }}
                                                    placeholder={t("companyRegulation.placeholders.boardOfDirectors.nationality") || "Select Nationality"}
                                                    searchable={true}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardOfDirectors.dateOfBirth") || "Director Date of Birth"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-calendar"></i>
                                            </span>
                                            <input
                                                type="date"
                                                className="input-box"
                                                value={boardOfDirectorsDateOfBirth}
                                                onChange={(e) => setBoardOfDirectorsDateOfBirth(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardOfDirectors.position") || "Director Position"}</label>
                                        <div className="input-wrapper">
                                            <span className="input-icon">
                                                <i className="fa-solid fa-briefcase"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="input-box"
                                                placeholder={t("companyRegulation.placeholders.boardOfDirectors.position") || "Please enter the director's position"}
                                                value={boardOfDirectorsPosition}
                                                onChange={(e) => setBoardOfDirectorsPosition(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-6">
                                        <label>{t("companyRegulation.labels.boardOfDirectors.documentType") || "Document Type"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={[
                                                        { value: 0, label: t("companyRegulation.labels.boardOfDirectors.documentTypeOptions.idCard") || "ID CARD" },
                                                        { value: 1, label: t("companyRegulation.labels.boardOfDirectors.documentTypeOptions.passport") || "PASSPORT" },
                                                    ]}
                                                    value={
                                                        boardOfDirectorsDocumentType !== null && boardOfDirectorsDocumentType !== undefined
                                                            ? {
                                                                value: boardOfDirectorsDocumentType,
                                                                label:
                                                                    boardOfDirectorsDocumentType === 0
                                                                        ? t("companyRegulation.labels.boardOfDirectors.documentTypeOptions.idCard") || "ID CARD"
                                                                        : t("companyRegulation.labels.boardOfDirectors.documentTypeOptions.passport") || "PASSPORT",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setBoardOfDirectorsDocumentType(selected ? selected.value : null);
                                                        // Clear images when document type changes
                                                        if (selected?.value === 1) {
                                                            // Switching to passport - clear ID card images
                                                            setBoardOfDirectorsFrontImage(null);
                                                            setBoardOfDirectorsFrontImagePreview(null);
                                                            setBoardOfDirectorsBackImage(null);
                                                            setBoardOfDirectorsBackImagePreview(null);
                                                        } else if (selected?.value === 0) {
                                                            // Switching to ID card - clear passport image
                                                            setBoardOfDirectorsMainImage(null);
                                                            setBoardOfDirectorsMainImagePreview(null);
                                                        }
                                                    }}
                                                    placeholder={t("companyRegulation.labels.boardOfDirectors.documentTypePlaceholder") || "Select Document Type"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ID CARD Images (Front and Back) */}
                                {boardOfDirectorsDocumentType === 0 && (
                                    <>
                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.boardOfDirectors.frontImage") || "ID Front"}</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (file) {
                                                            setBoardOfDirectorsFrontImage(file);
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setBoardOfDirectorsFrontImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                    className="file-input"
                                                    id="boardOfDirectorsFrontImageInput"
                                                />
                                                <label htmlFor="boardOfDirectorsFrontImageInput" className="file-upload-area">
                                                    {boardOfDirectorsFrontImagePreview ? (
                                                        <div className="image-preview-container">
                                                            <img
                                                                src={boardOfDirectorsFrontImagePreview}
                                                                alt={t("companyRegulation.labels.boardOfDirectors.frontImage") || "ID Front preview"}
                                                                className="uploaded-image"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setBoardOfDirectorsFrontImage(null);
                                                                    setBoardOfDirectorsFrontImagePreview(null);
                                                                    const input = document.getElementById("boardOfDirectorsFrontImageInput");
                                                                    if (input) input.value = "";
                                                                }}
                                                                className="remove-image-btn"
                                                                aria-label="Remove image"
                                                            >
                                                                <i className="fa-solid fa-times"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle change-image-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById("boardOfDirectorsFrontImageInput")?.click();
                                                                }}
                                                                aria-label="Change image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="camera-icon-placeholder">
                                                                <i className="fa-solid fa-camera"></i>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    document.getElementById("boardOfDirectorsFrontImageInput")?.click();
                                                                }}
                                                                aria-label="Upload image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                            <span className="document-image-text">
                                                                {t("companyRegulation.labels.boardOfDirectors.frontImage") || "ID Front"}
                                                            </span>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.boardOfDirectors.backImage") || "ID Back"}</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (file) {
                                                            setBoardOfDirectorsBackImage(file);
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setBoardOfDirectorsBackImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                    className="file-input"
                                                    id="boardOfDirectorsBackImageInput"
                                                />
                                                <label htmlFor="boardOfDirectorsBackImageInput" className="file-upload-area">
                                                    {boardOfDirectorsBackImagePreview ? (
                                                        <div className="image-preview-container">
                                                            <img
                                                                src={boardOfDirectorsBackImagePreview}
                                                                alt={t("companyRegulation.labels.boardOfDirectors.backImage") || "ID Back preview"}
                                                                className="uploaded-image"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setBoardOfDirectorsBackImage(null);
                                                                    setBoardOfDirectorsBackImagePreview(null);
                                                                    const input = document.getElementById("boardOfDirectorsBackImageInput");
                                                                    if (input) input.value = "";
                                                                }}
                                                                className="remove-image-btn"
                                                                aria-label="Remove image"
                                                            >
                                                                <i className="fa-solid fa-times"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle change-image-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById("boardOfDirectorsBackImageInput")?.click();
                                                                }}
                                                                aria-label="Change image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="camera-icon-placeholder">
                                                                <i className="fa-solid fa-camera"></i>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    document.getElementById("boardOfDirectorsBackImageInput")?.click();
                                                                }}
                                                                aria-label="Upload image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                            <span className="document-image-text">
                                                                {t("companyRegulation.labels.boardOfDirectors.backImage") || "ID Back"}
                                                            </span>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* PASSPORT Image (Main Image) */}
                                {boardOfDirectorsDocumentType === 1 && (
                                    <div className="form-group">
                                        <label>{t("companyRegulation.labels.boardOfDirectors.mainImage") || "Main Image"}</label>
                                        <div className="file-upload-wrapper">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const file = e.target.files?.[0];
                                                    if (file) {
                                                        setBoardOfDirectorsMainImage(file);
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => {
                                                            setBoardOfDirectorsMainImagePreview(reader.result);
                                                        };
                                                        reader.readAsDataURL(file);
                                                    }
                                                }}
                                                className="file-input"
                                                id="boardOfDirectorsMainImageInput"
                                            />
                                            <label htmlFor="boardOfDirectorsMainImageInput" className="file-upload-area">
                                                {boardOfDirectorsMainImagePreview ? (
                                                    <div className="image-preview-container">
                                                        <img
                                                            src={boardOfDirectorsMainImagePreview}
                                                            alt={t("companyRegulation.labels.boardOfDirectors.mainImage") || "Main image preview"}
                                                            className="uploaded-image"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setBoardOfDirectorsMainImage(null);
                                                                setBoardOfDirectorsMainImagePreview(null);
                                                                const input = document.getElementById("boardOfDirectorsMainImageInput");
                                                                if (input) input.value = "";
                                                            }}
                                                            className="remove-image-btn"
                                                            aria-label="Remove image"
                                                        >
                                                            <i className="fa-solid fa-times"></i>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="upload-button-circle change-image-btn"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                document.getElementById("boardOfDirectorsMainImageInput")?.click();
                                                            }}
                                                            aria-label="Change image"
                                                        >
                                                            <i className="fa-solid fa-camera"></i>
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="camera-icon-placeholder">
                                                            <i className="fa-solid fa-camera"></i>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className="upload-button-circle"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                document.getElementById("boardOfDirectorsMainImageInput")?.click();
                                                            }}
                                                            aria-label="Upload image"
                                                        >
                                                            <i className="fa-solid fa-camera"></i>
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                        <span className="document-image-text">
                                                            {t("companyRegulation.labels.boardOfDirectors.mainImage") || "Main Image"}
                                                        </span>
                                                    </>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                )}

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.boardOfDirectors.ownerPercentage") || "Owner Percentage"}</label>
                                    <div className="input-wrapper">
                                        <span className="input-icon">
                                            <i className="fa-solid fa-percent"></i>
                                        </span>
                                        <input
                                            type="number"
                                            className="input-box"
                                            placeholder="0"
                                            min="0"
                                            max="100"
                                            value={boardOfDirectorsOwnerPercentage}
                                            onChange={(e) => setBoardOfDirectorsOwnerPercentage(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox-row">
                                        <input
                                            type="checkbox"
                                            checked={boardOfDirectorsIsPep}
                                            onChange={(e) => setBoardOfDirectorsIsPep(e.target.checked)}
                                            className="custom-checkbox"
                                        />
                                        <label onClick={() => setBoardOfDirectorsIsPep(!boardOfDirectorsIsPep)}>
                                            {t("companyRegulation.labels.boardOfDirectors.isPep") || "Are you a Politically Exposed Person or a Relative or Close Associate of a PEP?"}
                                        </label>
                                    </div>
                                </div>
                            </section>

                            {/* Beneficial Right Owner */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.beneficialRightOwner") ||
                                        "Beneficial Right Owner"}
                                </h2>
                                <div className="form-row">
                                    <div className="form-group col-12">
                                        <label>{t("companyRegulation.labels.beneficialRightOwner.type") || "Type"}</label>
                                        <div className="input-wrapper">
                                            <div className="dropdown-wrapper">
                                                <CustomDropdown
                                                    options={[
                                                        { value: "same", label: t("companyRegulation.labels.beneficialRightOwner.typeOptions.same") || "Same" },
                                                        { value: "other", label: t("companyRegulation.labels.beneficialRightOwner.typeOptions.other") || "Other" },
                                                    ]}
                                                    value={
                                                        beneficialRightOwnerType
                                                            ? {
                                                                value: beneficialRightOwnerType,
                                                                label:
                                                                    beneficialRightOwnerType === "same"
                                                                        ? t("companyRegulation.labels.beneficialRightOwner.typeOptions.same") || "Same"
                                                                        : t("companyRegulation.labels.beneficialRightOwner.typeOptions.other") || "Other",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setBeneficialRightOwnerType(selected ? selected.value : null);
                                                        // Clear fields when switching to "same"
                                                        if (selected?.value === "same") {
                                                            setBeneficialRightOwnerFullName("");
                                                            setBeneficialRightOwnerAddress("");
                                                            setBeneficialRightOwnerMobilePhone("");
                                                            setBeneficialRightOwnerFrontImage(null);
                                                            setBeneficialRightOwnerFrontImagePreview(null);
                                                            setBeneficialRightOwnerBackImage(null);
                                                            setBeneficialRightOwnerBackImagePreview(null);
                                                        }
                                                    }}
                                                    placeholder={t("companyRegulation.labels.beneficialRightOwner.typePlaceholder") || "Select Type"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {beneficialRightOwnerType === "other" && (
                                    <>
                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.beneficialRightOwner.fullName") || "Full Name"}</label>
                                            <div className="input-wrapper">
                                                <span className="input-icon">
                                                    <i className="fa-solid fa-user"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    className="input-box"
                                                    placeholder="Full Name"
                                                    value={beneficialRightOwnerFullName}
                                                    onChange={(e) => setBeneficialRightOwnerFullName(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.beneficialRightOwner.address") || "Address"}</label>
                                            <div className="input-wrapper">
                                                <span className="input-icon">
                                                    <i className="fa-solid fa-map-marker-alt"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    className="input-box"
                                                    placeholder="Address"
                                                    value={beneficialRightOwnerAddress}
                                                    onChange={(e) => setBeneficialRightOwnerAddress(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.beneficialRightOwner.mobilePhone") || "Mobile Phone"}</label>
                                            <div className="input-wrapper">
                                                <span className="input-icon">
                                                    <i className="fa-solid fa-phone"></i>
                                                </span>
                                                <input
                                                    type="tel"
                                                    className="input-box"
                                                    placeholder="Mobile Phone"
                                                    value={beneficialRightOwnerMobilePhone}
                                                    onChange={(e) => setBeneficialRightOwnerMobilePhone(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.beneficialRightOwner.frontImage") || "ID Front"}</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (file) {
                                                            setBeneficialRightOwnerFrontImage(file);
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setBeneficialRightOwnerFrontImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                    className="file-input"
                                                    id="beneficialRightOwnerFrontImageInput"
                                                />
                                                <label htmlFor="beneficialRightOwnerFrontImageInput" className="file-upload-area">
                                                    {beneficialRightOwnerFrontImagePreview ? (
                                                        <div className="image-preview-container">
                                                            <img
                                                                src={beneficialRightOwnerFrontImagePreview}
                                                                alt={t("companyRegulation.labels.beneficialRightOwner.frontImage") || "ID Front preview"}
                                                                className="uploaded-image"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setBeneficialRightOwnerFrontImage(null);
                                                                    setBeneficialRightOwnerFrontImagePreview(null);
                                                                    const input = document.getElementById("beneficialRightOwnerFrontImageInput");
                                                                    if (input) input.value = "";
                                                                }}
                                                                className="remove-image-btn"
                                                                aria-label="Remove image"
                                                            >
                                                                <i className="fa-solid fa-times"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle change-image-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById("beneficialRightOwnerFrontImageInput")?.click();
                                                                }}
                                                                aria-label="Change image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="camera-icon-placeholder">
                                                                <i className="fa-solid fa-camera"></i>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    document.getElementById("beneficialRightOwnerFrontImageInput")?.click();
                                                                }}
                                                                aria-label="Upload image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                            <span className="document-image-text">
                                                                {t("companyRegulation.labels.beneficialRightOwner.frontImage") || "ID Front"}
                                                            </span>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>{t("companyRegulation.labels.beneficialRightOwner.backImage") || "ID Back"}</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0];
                                                        if (file) {
                                                            setBeneficialRightOwnerBackImage(file);
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setBeneficialRightOwnerBackImagePreview(reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                    className="file-input"
                                                    id="beneficialRightOwnerBackImageInput"
                                                />
                                                <label htmlFor="beneficialRightOwnerBackImageInput" className="file-upload-area">
                                                    {beneficialRightOwnerBackImagePreview ? (
                                                        <div className="image-preview-container">
                                                            <img
                                                                src={beneficialRightOwnerBackImagePreview}
                                                                alt={t("companyRegulation.labels.beneficialRightOwner.backImage") || "ID Back preview"}
                                                                className="uploaded-image"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setBeneficialRightOwnerBackImage(null);
                                                                    setBeneficialRightOwnerBackImagePreview(null);
                                                                    const input = document.getElementById("beneficialRightOwnerBackImageInput");
                                                                    if (input) input.value = "";
                                                                }}
                                                                className="remove-image-btn"
                                                                aria-label="Remove image"
                                                            >
                                                                <i className="fa-solid fa-times"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle change-image-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    document.getElementById("beneficialRightOwnerBackImageInput")?.click();
                                                                }}
                                                                aria-label="Change image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="camera-icon-placeholder">
                                                                <i className="fa-solid fa-camera"></i>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="upload-button-circle"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    document.getElementById("beneficialRightOwnerBackImageInput")?.click();
                                                                }}
                                                                aria-label="Upload image"
                                                            >
                                                                <i className="fa-solid fa-camera"></i>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                            <span className="document-image-text">
                                                                {t("companyRegulation.labels.beneficialRightOwner.backImage") || "ID Back"}
                                                            </span>
                                                        </>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </section>

                            {/* Company Document */}
                            <section className="company-regulation-section company-column">
                                <h2 className="company-section-title">
                                    {t("companyRegulation.sections.companyDocument") ||
                                        "Company Document"}
                                </h2>
                                
                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.companyDocument.articleOfIncorporation") || "Article of Incorporation"}</label>
                                    <div className="file-upload-wrapper">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    setCompanyDocumentArticleOfIncorporation(file);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setCompanyDocumentArticleOfIncorporationPreview(reader.result);
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }}
                                            className="file-input"
                                            id="companyDocumentArticleOfIncorporationInput"
                                        />
                                        <label htmlFor="companyDocumentArticleOfIncorporationInput" className="file-upload-area">
                                            {companyDocumentArticleOfIncorporationPreview ? (
                                                <div className="image-preview-container">
                                                    <img
                                                        src={companyDocumentArticleOfIncorporationPreview}
                                                        alt={t("companyRegulation.labels.companyDocument.articleOfIncorporation") || "Article of Incorporation preview"}
                                                        className="uploaded-image"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setCompanyDocumentArticleOfIncorporation(null);
                                                            setCompanyDocumentArticleOfIncorporationPreview(null);
                                                            const input = document.getElementById("companyDocumentArticleOfIncorporationInput");
                                                            if (input) input.value = "";
                                                        }}
                                                        className="remove-image-btn"
                                                        aria-label="Remove image"
                                                    >
                                                        <i className="fa-solid fa-times"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle change-image-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById("companyDocumentArticleOfIncorporationInput")?.click();
                                                        }}
                                                        aria-label="Change image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="camera-icon-placeholder">
                                                        <i className="fa-solid fa-camera"></i>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("companyDocumentArticleOfIncorporationInput")?.click();
                                                        }}
                                                        aria-label="Upload image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                    <span className="document-image-text">
                                                        {t("companyRegulation.labels.companyDocument.articleOfIncorporation") || "Article of Incorporation"}
                                                    </span>
                                                </>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.companyDocument.commercialRegistration") || "Commercial Registration"}</label>
                                    <div className="file-upload-wrapper">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    setCompanyDocumentCommercialRegistration(file);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setCompanyDocumentCommercialRegistrationPreview(reader.result);
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }}
                                            className="file-input"
                                            id="companyDocumentCommercialRegistrationInput"
                                        />
                                        <label htmlFor="companyDocumentCommercialRegistrationInput" className="file-upload-area">
                                            {companyDocumentCommercialRegistrationPreview ? (
                                                <div className="image-preview-container">
                                                    <img
                                                        src={companyDocumentCommercialRegistrationPreview}
                                                        alt={t("companyRegulation.labels.companyDocument.commercialRegistration") || "Commercial Registration preview"}
                                                        className="uploaded-image"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setCompanyDocumentCommercialRegistration(null);
                                                            setCompanyDocumentCommercialRegistrationPreview(null);
                                                            const input = document.getElementById("companyDocumentCommercialRegistrationInput");
                                                            if (input) input.value = "";
                                                        }}
                                                        className="remove-image-btn"
                                                        aria-label="Remove image"
                                                    >
                                                        <i className="fa-solid fa-times"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle change-image-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById("companyDocumentCommercialRegistrationInput")?.click();
                                                        }}
                                                        aria-label="Change image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="camera-icon-placeholder">
                                                        <i className="fa-solid fa-camera"></i>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("companyDocumentCommercialRegistrationInput")?.click();
                                                        }}
                                                        aria-label="Upload image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                    <span className="document-image-text">
                                                        {t("companyRegulation.labels.companyDocument.commercialRegistration") || "Commercial Registration"}
                                                    </span>
                                                </>
                                            )}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>{t("companyRegulation.labels.companyDocument.commercialCircular") || "Commercial Circular"}</label>
                                    <div className="file-upload-wrapper">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    setCompanyDocumentCommercialCircular(file);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setCompanyDocumentCommercialCircularPreview(reader.result);
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }}
                                            className="file-input"
                                            id="companyDocumentCommercialCircularInput"
                                        />
                                        <label htmlFor="companyDocumentCommercialCircularInput" className="file-upload-area">
                                            {companyDocumentCommercialCircularPreview ? (
                                                <div className="image-preview-container">
                                                    <img
                                                        src={companyDocumentCommercialCircularPreview}
                                                        alt={t("companyRegulation.labels.companyDocument.commercialCircular") || "Commercial Circular preview"}
                                                        className="uploaded-image"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setCompanyDocumentCommercialCircular(null);
                                                            setCompanyDocumentCommercialCircularPreview(null);
                                                            const input = document.getElementById("companyDocumentCommercialCircularInput");
                                                            if (input) input.value = "";
                                                        }}
                                                        className="remove-image-btn"
                                                        aria-label="Remove image"
                                                    >
                                                        <i className="fa-solid fa-times"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle change-image-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            document.getElementById("companyDocumentCommercialCircularInput")?.click();
                                                        }}
                                                        aria-label="Change image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="camera-icon-placeholder">
                                                        <i className="fa-solid fa-camera"></i>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="upload-button-circle"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("companyDocumentCommercialCircularInput")?.click();
                                                        }}
                                                        aria-label="Upload image"
                                                    >
                                                        <i className="fa-solid fa-camera"></i>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </button>
                                                    <span className="document-image-text">
                                                        {t("companyRegulation.labels.companyDocument.commercialCircular") || "Commercial Circular"}
                                                    </span>
                                                </>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <CustomButton 
                            className="next-button" 
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading 
                                ? (t("companyRegulation.submitting") || "Submitting...") 
                                : (t("companyRegulation.nextButton") || "Next")
                            }
                        </CustomButton>
                    </div>
                </div>
            </CustomCard>
        </div>
    );
}


